import script from "./Main.vue?vue&type=script&setup=true&lang=ts"
export * from "./Main.vue?vue&type=script&setup=true&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=9dc4f416&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dc4f416"]])

export default __exports__